import React from "react";
import { Alert, Box, Collapse, Fade, Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Grid from "@mui/material/Grid";
import Info from "@mui/icons-material/Info";
import { Vendor, vendorMeta } from "../vendorConfig";
import { VendorCard } from "./VendorCard";

interface Props {
  selectedVendor: Vendor | null;
  onSelect: (vendor: Vendor) => void;
  onContinue: () => void;
  isLoading?: boolean;
}

export const VendorSelector: React.FC<Props> = ({ selectedVendor, onSelect, onContinue, isLoading }) => (
  <Fade in timeout={300}>
    <Stack spacing={4}>
      <Grid container spacing={2.5}>
        {(Object.keys(vendorMeta) as Vendor[]).map((vendor) => (
          <Grid key={vendor} size={12}>
            <VendorCard
              vendor={vendor}
              selected={selectedVendor === vendor}
              onSelect={onSelect}
              meta={vendorMeta[vendor]}
            />
          </Grid>
        ))}
      </Grid>

      <Collapse in={!!selectedVendor}>
        <Alert severity="info" icon={<Info />} sx={{ borderRadius: 2, mb: 2, justifyContent: "center" }}>
          <Typography variant="body2" fontWeight={500}>
            {selectedVendor && vendorMeta[selectedVendor].label} requirements:
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2, mt: 0.5 }}>
            {selectedVendor &&
              vendorMeta[selectedVendor].help.map((hint, i) => (
                <Typography variant="body2" key={i} color="text.secondary">
                  {hint}
                </Typography>
              ))}
          </Box>
        </Alert>
      </Collapse>

      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        <LoadingButton variant="contained" onClick={onContinue} disabled={!selectedVendor || isLoading} size="large" sx={{ px: 4 }}>
          Continue
        </LoadingButton>
      </Stack>
    </Stack>
  </Fade>
);
